import { render, staticRenderFns } from "./RelatorioLpsNaoVisitaList copy.vue?vue&type=template&id=608d84f4&scoped=true"
import script from "./RelatorioLpsNaoVisitaList copy.vue?vue&type=script&lang=js"
export * from "./RelatorioLpsNaoVisitaList copy.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLpsNaoVisitaList copy.vue?vue&type=style&index=0&id=608d84f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d84f4",
  null
  
)

export default component.exports